/**
 * Treść sekcji FAQ. Odpowiedzi trzymamy jako HTML - tak samo jak treści zagadek
 * w quests.js - żeby dało się w nich użyć pogrubień i list bez dodatkowego parsera.
 * Pole `keys` to dodatkowe hasła dla wyszukiwarki: gracz szukający "kamery"
 * ma trafić też na odpowiedzi, które mówią o aparacie.
 *
 * Dwie główne kategorie. "Rozgrywka" dzieli się dalej na podkategorie (`groups`),
 * "Problemy techniczne" to płaska lista pytań (`items`) - gracz z problemem
 * szuka konkretnego objawu, a nie tematu.
 */
const faqData = [
    {
        id: 'rozgrywka',
        title: 'Rozgrywka',
        groups: [
            {
                id: 'start',
                title: 'Start gry i drużyna',
                items: [
                    {
                        q: 'Czy możemy przerwać grę i wrócić później?',
                        a: '<p>Tak. Postęp zapisuje się na serwerze, nie na telefonie. Otwórzcie ten sam link przesłany w e-mailu i wybierzcie <strong>Kontynuuj grę</strong>.</p>',
                        keys: 'przerwa pauza wrocic pozniej link'
                    }
                ]
            },
            {
                id: 'punkty',
                title: 'Punkty i podpowiedzi',
                items: [
                    {
                        q: 'Za co dostajemy punkty?',
                        a: '<p>Za każdą rozwiązaną zagadkę drużyna dostaje <strong>200 punktów</strong>.</p>',
                        keys: 'punktacja wynik ranking'
                    },
                    {
                        q: 'Ile kosztuje podpowiedź?',
                        a: '<p>Skorzystanie z podpowiedzi w danej zagadce obniża wynik o <strong>50 punktów</strong>. Kolejne podpowiedzi w tej samej zagadce są już bezpłatne, więc jeśli i tak sięgacie po pierwszą, możecie spokojnie odsłonić następne.</p>'
                            + '<p>Podpowiedzi odsłaniają się po kolei — druga dopiero po użyciu pierwszej.</p>',
                        keys: 'hint podpowiedzi kara punkty'
                    },
                    {
                        q: 'Co się stanie, jeśli pominiemy zagadkę?',
                        a: '<p>W zakładce <strong>Pomoc</strong> jest przycisk <strong>Idź do następnej zagadki</strong>. Fabuła ruszy dalej, ale za pominiętą zagadkę nie dostaniecie punktów.</p>',
                        keys: 'pominac przeskoczyc dalej nastepna'
                    },
                    {
                        q: 'Czy za błędne odpowiedzi tracimy punkty?',
                        a: '<p>Nie. Odpowiedzi możecie wpisywać dowolną ilość razy. Wyjątkiem jest jedna zagadka fabularna z jedną próbą — aplikacja wyraźnie o tym uprzedza i sama pokazuje wtedy poprawną odpowiedź.</p>',
                        keys: 'bledna zla odpowiedz proby kara'
                    },
                    {
                        q: 'Gdzie zobaczymy końcowy wynik?',
                        a: '<p>Po ostatniej zagadce pojawia się ekran podsumowania z wynikiem drużyny i statystykami gry.</p>',
                        keys: 'wynik koniec podsumowanie statystyki'
                    }
                ]
            },
            {
                id: 'zagadki',
                title: 'Rozwiązywanie zagadek',
                items: [
                    {
                        q: 'Jak wpisywać odpowiedzi?',
                        a: '<p>Wpiszcie odpowiedź w polu na dole zagadki i wybierzcie przycisk do wysłania odpowiedzi. Nie musicie pilnować wielkości liter, polskich znaków ani dodatkowych spacji — „ŁAWKA”, „lawka” i „ Ławka ” są traktowane tak samo.</p>',
                        keys: 'odpowiedz wpisywanie pole enter'
                    },
                    {
                        q: 'Czy możemy wrócić do wcześniejszej zagadki?',
                        a: '<p>Przewijając zakładkę <strong>Czat</strong> w górę możecie przejrzeć poprzednie wiadomości od Wiktora. Nie można wrócić do wcześniejszego zadania.</p>',
                        keys: 'powrot wczesniejsza historia czat'
                    },
                    {
                        q: 'Utknęliśmy i nie mamy pomysłu.',
                        a: '<p>Zróbcie kolejno: podpowiedź 1 → podpowiedź 2 → podpowiedź 3 (koszt to tylko pierwsze skorzystanie), a jeśli to nie pomoże — <strong>Idź do następnej zagadki</strong>.</p>',
                        keys: 'utknelismy pomoc podpowiedz nie wiemy'
                    }
                ]
            },
            {
                id: 'mapa',
                title: 'Mapa i lokalizacja',
                items: [
                    {
                        q: 'Co oznaczają punkty na mapie?',
                        a: '<p>To miejsca powiązane z zagadkami. Wyróżniony punkt dotyczy zagadki, którą właśnie rozwiązujecie. Po kliknięciu markera zobaczycie krótki opis.</p>',
                        keys: 'mapa markery punkty miejsca'
                    },
                    {
                        q: 'Mam zagadkę w której trzeba wpisać współrzędne — gdzie to zrobić?',
                        a: '<p>W tej jednej zagadce na mapie pojawia się pole wyszukiwania. Wpiszcie współrzędne w formacie <strong>52.2455, 21.0015</strong>. Aplikacja zweryfikuje ich poprawność.</p>',
                        keys: 'wspolrzedne koordynaty gps mapa'
                    },
                    {
                        q: 'Treść zagadki nie chce się odblokować.',
                        a: '<p>Niektóre zagadki odblokowują się dopiero na miejscu — trzeba podejść na około 30 metrów od wskazanego punktu. Wyjdźcie na otwartą przestrzeń, poczekajcie kilkanaście sekund i upewnijcie się, że macie włączony GPS oraz zgodę na lokalizację.</p>'
                            + '<p>Wystarczy, że w strefę wejdzie jedna osoba z drużyny — treść odblokuje się wszystkim.</p>',
                        keys: 'gps lokalizacja strefa zablokowane nie odblokowuje'
                    }
                ]
            },
            {
                id: 'ar',
                title: 'AR — rzeczywistość rozszerzona',
                items: [
                    {
                        q: 'Na czym polega AR w grze?',
                        a: '<p>Aplikacja pokazuje obraz z aparatu, a na nim wirtualne obiekty: skrzynie z zamkiem szyfrowym, tablice i efekty. Zagadkę rozwiązujecie, wchodząc z nimi w interakcję na ekranie.</p>',
                        keys: 'ar kamera aparat rzeczywistosc rozszerzona'
                    },
                    {
                        q: 'Jak uruchomić AR?',
                        a: '<p>W zagadce naciśnijcie <strong>Otwórz AR</strong>. Przy pierwszym uruchomieniu telefon zapyta o dostęp do aparatu, a na iPhonie także o dostęp do czujników ruchu — zgódźcie się na oba.</p>'
                            + '<p>AR zamyka się krzyżykiem <strong>✖</strong> w rogu.</p>',
                        keys: 'ar kamera aparat uprawnienia zgoda uruchomienie'
                    },
                    {
                        q: 'Skąd wiem, że zagadka AR została zaliczona?',
                        a: '<p>Usłyszycie dźwięk potwierdzenia, dostaniecie punkty, a w czacie pojawi się kolejna wiadomość Wiktora.</p>',
                        keys: 'zaliczone potwierdzenie dzwiek punkty'
                    }
                ]
            },
            {
                id: 'zdjecia',
                title: 'Zagadki ze zdjęciami obiektów',
                items: [
                    {
                        q: 'Na czym polega zagadka ze zdjęciami obiektów?',
                        a: '<p>Dostajecie zdjęcia referencyjne obiektów (część kadru jest zamazana) i ich przybliżone lokalizacje na mapie. Waszym zadaniem jest odnaleźć obiekty i sfotografować je aparatem w aplikacji, przyciskiem <strong>Zrób zdjęcie</strong>.</p>',
                        keys: 'zdjecia foto obiekty aparat referencje'
                    },
                    {
                        q: 'Jak zrobić zdjęcie, żeby zostało uznane?',
                        a: '<ul>'
                            + '<li>Ta sama <strong>perspektywa</strong> co na zdjęciu wzorcowym — stańcie mniej więcej tam, gdzie stał fotograf.</li>'
                            + '<li>Podobne <strong>zbliżenie</strong> — obiekt ma wypełniać kadr w takim samym stopniu.</li>'
                            + '<li>Telefon trzymany <strong>pionowo</strong>, bez przechylania.</li>'
                            + '<li>Dobre światło, w kadrze jak najmniej przypadkowych osób i samochodów.</li>'
                            + '</ul>',
                        keys: 'zdjecie perspektywa zblizenie kadr jak zrobic'
                    },
                    {
                        q: 'Ile obiektów trzeba sfotografować?',
                        a: '<p>Wszystkie z listy miniatur pod zagadką. Zagadka zostaje zaliczona jeśli zostaną zaliczone wszystkie zdjęcia.</p>',
                        keys: 'ile obiektow miniatury lista'
                    },
                    {
                        q: 'Dostaliśmy komunikat „Zdjęcie już wcześniej zaliczone”.',
                        a: '<p>To ten sam obiekt, który już macie na koncie. Poszukajcie pozostałych z listy.</p>',
                        keys: 'juz zaliczone duplikat'
                    }
                ]
            },
            {
                id: 'telefon',
                title: 'Telefon i SMS',
                items: [
                    {
                        q: 'Zagadka w której trzeba zadzwonić pod numer telefonu — jak to działa?',
                        a: '<p>Wykonujecie zwykłe połączenie ze swojego telefonu. Ważne: dzwońcie z <strong>tego numeru, który podaliście na starcie</strong> — po nim aplikacja rozpoznaje Waszą drużynę.</p>',
                        keys: 'telefon polaczenie dzwonic rozmowa numer'
                    },
                    {
                        q: 'Rozmowa się urwała albo osoba do której zadzwoniliście Was nie rozumie.',
                        a: '<p>Zadzwońcie jeszcze raz — liczba prób jest nieograniczona. Mówcie wyraźnie, pojedynczo (nie wszyscy naraz), stańcie w cichszym miejscu i włączcie głośnomówiący, żeby cała drużyna słyszała.</p>'
                            + '<p>Zakłócenia w rozmowie są też elementem fabuły.</p>',
                        keys: 'rozmowa urwala nie rozumie telefon zaklocenia'
                    },
                    {
                        q: 'Nie dostaliśmy SMS-a.',
                        a: '<p>Sprawdźcie, czy numer podany na starcie jest poprawny i czy macie zasięg. SMS-y są dodatkiem fabularnym i gra toczy się dalej. Bez nich można dalej kontynuować grę.</p>',
                        keys: 'sms wiadomosc numer zasieg spam'
                    },
                    {
                        q: 'Czy połączenie i SMS-y są płatne?',
                        a: '<p>Połączenie jest naliczane zgodnie z taryfą Waszego operatora, tak jak zwykły telefon. SMS-y od gry przychodzą do Was i nic nie kosztują.</p>',
                        keys: 'platne koszt taryfa operator sms telefon'
                    }
                ]
            }
        ]
    },
    {
        id: 'techniczne',
        title: 'Problemy techniczne',
        items: [
            {
                q: 'Aplikacja przestała reagować / nie przychodzą nowe wiadomości.',
                a: '<p>Zróbcie po kolei:</p>'
                    + '<ol>'
                    + '<li><strong>Pomoc → Odśwież</strong> (odnawia połączenie i pobiera aktualny stan gry).</li>'
                    + '<li>Odświeżenie strony w przeglądarce.</li>'
                    + '<li>Zamknięcie i ponowne otwarcie linku do gry.</li>'
                    + '</ol>',
                keys: 'zawiesila sie blad odswiez restart nie dziala'
            },
            {
                q: 'Brak reakcji po rozwiązaniu zagadki.',
                a: '<p>Przejdźcie do zakładki <strong>Czat</strong> — kolejne wiadomości Wiktora przychodzą z kilkusekundowym opóźnieniem, a to one odblokowują następną zagadkę. Jeśli po kilkudziesięciu sekundach nadal jest cisza, użyjcie <strong>Pomoc → Odśwież</strong>.</p>',
                keys: 'rozwiazana zagadka nic sie nie dzieje odswiez czat'
            },
            {
                q: 'Wróciliśmy do aplikacji po rozmowie telefonicznej i nic się nie dzieje.',
                a: '<p>Spróbujcie odświeżyć aplikację: <strong>Pomoc → Odśwież</strong> lub odświeżcie stronę w przeglądarce.</p>',
                keys: 'powrot telefon rozmowa polaczenie odswiez'
            },
            {
                q: 'Straciliśmy zasięg.',
                a: '<p>Gra wznowi połączenie sama, gdy internet wróci. Nie zamykajcie karty w tym czasie.</p>',
                keys: 'zasieg internet polaczenie offline'
            },
            {
                q: 'Czy odświeżenie strony skasuje nasz postęp?',
                a: '<p>Nie. Postęp, punkty i historia czatu są zapisane na serwerze i wczytywane są po odświeżeniu strony.</p>',
                keys: 'odswiezenie postep utrata zapis'
            },
            {
                q: 'Nie widzę swojej pozycji na mapie.',
                a: '<p>Aplikacja potrzebuje zgody na dostęp do lokalizacji. Jeśli na mapie widnieje komunikat „Brak dostępu do lokalizacji”, włączcie lokalizację w ustawieniach przeglądarki i odświeżcie stronę.</p>',
                keys: 'gps lokalizacja pozycja kropka mapa'
            },
            {
                q: 'Mapa nie chce się przesunąć dalej.',
                a: '<p>To celowe — mapa jest ograniczona do obszaru gry.</p>',
                keys: 'mapa przesuwanie obszar granica'
            },
            {
                q: 'Po włączeniu AR widzę czarny ekran.',
                a: '<p>Może to oznaczać że aplikacja nie ma dostępu do aparatu. Po nadaniu uprawnień odświeżcie stronę i uruchomcie AR ponownie.</p>',
                keys: 'czarny ekran kamera aparat uprawnienia zgoda nie dziala ar'
            },
            {
                q: 'Obiekt AR w ogóle się nie pojawia albo wisi w powietrzu.',
                a: '<ul>'
                    + '<li>Skierujcie aparat na płaskie, kontrastowe podłoże — najlepiej kostkę brukową lub trawnik.</li>'
                    + '<li>Powoli poruszajcie telefonem, żeby aplikacja rozpoznała otoczenie.</li>'
                    + '<li>Odsuńcie się 1–2 metry od obiektu.</li>'
                    + '<li>Jeśli obiekt pojawił się w złym miejscu lub w złej skali, użyjcie przycisku <strong>reset</strong> w widoku AR lub odświeżcie grę w przeglądarce i spróbujcie ponownie.</li>'
                    + '</ul>',
                keys: 'skrzynia nie widac tracking sledzenie reset skala ar'
            },
            {
                q: 'AR działa wolno albo się zacina.',
                a: '<p>Zamknijcie inne aplikacje działające w tle, wyłączcie tryb oszczędzania energii i spróbujcie jeszcze raz odpalić AR.</p>',
                keys: 'wolno zacina lagi wydajnosc przegrzewa bateria ar'
            },
            {
                q: 'Otworzyłem link z Facebooka/Instagrama/Messengera i kamera nie działa.',
                a: '<p>Wbudowane przeglądarki tych aplikacji blokują AR. Otwórzcie grę w zwykłym Chrome (Android) lub Safari (iPhone) — użyjcie w menu opcji „Otwórz w przeglądarce”.</p>',
                keys: 'facebook instagram messenger przegladarka kamera aparat ar'
            },
            {
                q: 'Aplikacja pokazuje „Nie rozpoznano zdjęcia”.',
                a: '<p>Podejdźcie bliżej lub cofnijcie się, poprawcie kąt na bardziej zgodny ze wzorcem i spróbujcie jeszcze raz — liczba prób jest nieograniczona.</p>',
                keys: 'nie rozpoznano zdjecie blad proby foto'
            },
            {
                q: 'Aparat nie chce się uruchomić przy robieniu zdjęcia.',
                a: '<p>Tak samo jak w AR: sprawdźcie uprawnienia do aparatu i wyłączcie tryb „Wersja na komputer”, a potem odświeżcie stronę.</p>',
                keys: 'kamera aparat uprawnienia nie dziala zdjecie'
            },
            {
                q: 'Bateria szybko się rozładowuje.',
                a: '<p>AR, aparat i GPS zużywają dużo energii — nie zostawiajcie AR otwartego, kiedy z niego nie korzystacie. Uwaga: tryb oszczędzania energii potrafi spowolnić AR.</p>',
                keys: 'bateria energia oszczedzanie powerbank'
            },
            {
                q: 'Nie słyszymy dźwięków gry.',
                a: '<p>Sprawdźcie przełącznik ciszy i głośność multimediów. Dźwięki potwierdzeń są udogodnieniem — nie są konieczne do ukończenia gry.</p>',
                keys: 'dzwiek glosnosc cisza audio'
            },
            {
                q: 'Czy do gry potrzebny jest internet?',
                a: '<p>Tak, przez cały czas gry — treści, mapa i AR ładują się z sieci.</p>',
                keys: 'internet dane transfer online'
            },
            {
                q: 'Nic nie pomaga.',
                a: '<p>Napiszcie na <a href="mailto:kontakt@secretgate.pl">kontakt@secretgate.pl</a>. Podajcie link do swojej gry, model telefonu, przeglądarkę i krótki opis tego, co się dzieje — to pozwoli nam pomóc najszybciej.</p>',
                keys: 'kontakt pomoc wsparcie mail'
            }
        ]
    }
];

export default faqData;
